import { SuperTokensConfig as SuperTokensConfigType } from "supertokens-auth-react/lib/build/types";
import Passwordless from "supertokens-auth-react/recipe/passwordless";
import Session from "supertokens-auth-react/recipe/session";

import {
  getApiDomain,
  getAppName,
  getBaseApiPath,
  getBaseAppPath,
  getWebsiteDomain,
} from ".";

export const SuperTokensConfig: SuperTokensConfigType = {
  appInfo: {
    appName: getAppName(),
    apiDomain: getApiDomain(),
    apiBasePath: getBaseApiPath(),
    websiteDomain: getWebsiteDomain(),
    websiteBasePath: getBaseAppPath(),
  },
  // recipeList contains all the modules that you want to
  // use from SuperTokens. See the full list here: https://supertokens.com/docs/guides
  recipeList: [
    Passwordless.init({
      contactMethod: "EMAIL",

      preAPIHook: async (context) => {
        const action = context.action;

        if (action === "PASSWORDLESS_CREATE_CODE") {
          if (!context.requestInit.headers) {
            context.requestInit.headers = {};
          }

          (context.requestInit.headers as Record<string, string>)[
            "x-recaptcha-token"
          ] = window.recaptchaToken || "";
        }

        return context;
      },
    }),
    Session.init({
      sessionTokenFrontendDomain: `.${getWebsiteDomain().split("://")[1]}`,
      sessionTokenBackendDomain: getApiDomain(),
    }),
  ],
};
